import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../constants';
import { HttpClient } from '@angular/common/http';
import { AuthorizedToken } from '../typings';

@Injectable()
export class AuthService {

  constructor(private http: HttpClient) { }

  public IsAuthorized(token?: string): Observable<boolean> {
    const params: any = {
      'encryptedToken': token
    };
    return this.http.get<boolean>(`${Constants.Api.IsAuthorized}`, { params: params });
  }

  public getTokenConfig(token?: string): Observable<AuthorizedToken> {
    const params: any = {
      'token': token
    };
    return this.http.get<AuthorizedToken>(`${Constants.Api.TokenConfig}`, { params: params }); 
  }

   public refreshTokenConfig(encryptedToken?: string): Observable<AuthorizedToken> {
    const params: any = {
      'encryptedToken': encryptedToken
    };
    return this.http.get<AuthorizedToken>(`${Constants.Api.RefreshConfig}`, { params: params }); 
  }

  public getLanguage(token: string | null): Observable<string> {
    const params: any = {
      'encryptedToken': token
    };
    return this.http.get<string>(`${Constants.Api.Language}`, { params: params });
  }
}
